import { BookLink } from './BookLink'
import { withBookLink } from './withBookLink'

const ConnectedBookLing = withBookLink(BookLink)

export { ConnectedBookLing as BookLink }
